import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MdOutlineKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";

const EventHall = () => {
  const halls = [
    {
      id: 1,
      image: "/assets/hall-1.JPG",
      title: "Utsav Hall",
      content:
        "At Sastha Grand, we offer versatile meeting and event spaces tailored to your needs. Whether you’re hosting a small team meeting, a large conference, or an elegant celebration, our Utsav Hall provides a flexible",
    },
    {
      id: 2,
      image: "/assets/meetinghall-1.webp",
      title: "Events Made Easy",
      content:
        "At Sastha Grand, we offer versatile meeting and event spaces tailored to your needs. Whether you’re hosting a small team meeting, a large conference",
    },
    {
      id: 3,
      image: "/assets/meetinghall-2.webp",
      title: "Dining Setup",
      content:
        "Whether it’s an intimate family gathering or a professional luncheon, Sastha Grand offers elegant round-table arrangements that suit any event style. ",
    },
  ];

  const CARD_W = 450;
  const GAP = 40;
  const STEP = CARD_W + GAP;

  const maxIndex = useMemo(() => Math.max(0, halls.length - 2), [halls.length]);

  const [index, setIndex] = useState(0);
  const [cardW, setCardW] = useState(446); // default desktop
  const [gap, setGap] = useState(40); // mr-10 = 40px
  const [visibleCount, setVisibleCount] = useState(2);

  const trackWrapRef = useRef(null);

  const next = () => setIndex((p) => Math.min(p + 1, maxIndex));
  const prev = () => setIndex((p) => Math.max(p - 1, 0));

  useEffect(() => {
    const el = trackWrapRef.current;
    if (!el) return;

    const ro = new ResizeObserver((entries) => {
      const w = entries[0].contentRect.width;

      // breakpoints based on available space
      if (w < 520) {
        setVisibleCount(1);
        setCardW(Math.min(340, w - 20)); // keep padding
        setGap(16);
      } else if (w < 900) {
        setVisibleCount(1);
        setCardW(420);
        setGap(20);
      } else {
        setVisibleCount(2);
        setCardW(446);
        setGap(40);
      }
    });

    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    setIndex((p) => Math.min(p, maxIndex));
  }, [maxIndex]);

  const leftFrames = [
    "/assets/hall-1.JPG",
    "/assets/hall-2.jpg",
    "/assets/hall-3.jpg",
    "/assets/hall-4.jpg",
    "/assets/hall-5.JPG",
  ];

  const rightFrames = [
    "/assets/frame-6.svg",
    "/assets/frame-7.svg",
    "/assets/frame-8.svg",
    "/assets/frame-9.svg",
  ];

  return (
    <>
      <section className="hidden md:block w-full  bg-[#FFFEF2]  overflow-hidden relative">
        <div className="px-5 sm:px-10 md:px-20 flex flex-col h-[750px] justify-between   lg:flex-row gap-10 lg:gap-16 bg-white">
          <div className="flex flex-col text-start justify-start w-[600px] h-[130px]   mt-[15%] ">
            <p className="font-cinzel font-normal text-[20px] sm:text-[28px] md:text-[44px] text-primary leading-snug md:leading-none">
              let’s celebrate your all auspicious events in our unforgettable
              venue.
            </p>
            <p className="mt-6 sm:mt-10 font-creto font-thin text-[16px] sm:text-[18px] md:text-[20px] text-primary leading-relaxed">
              Set in a meticulously restored Beaux-Arts building, The Chemists’
              Club Hotel offers a refined stay in the heart of Midtown
              Manhattan. Just steps from Bryant Park and the iconic locations
              nearby. Enjoy a seamless experience for all your events and
              meetings.
            </p>
          </div>

          <div className="flex overflow-hidden space-x-10">
            <div className="relative overflow-hidden">
              <div className="animate-scrollSlow flex flex-col gap-4">
                {[...leftFrames, ...leftFrames].map((img, i) => (
                  <div key={i} className="w-[160px]">
                    <img
                      src={img}
                      className="w-full h-full object-cover"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="relative overflow-hidden">
              <div className="animate-scrollFast flex flex-col gap-4">
               {[...rightFrames, ...rightFrames].map((img, i) => (
                  <div key={i} className="w-[330px]">
                    <img
                      src={img}
                      className="w-full h-full object-cover"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                ))} 
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-primary font-calson text-center text-[64px] mt-[5%]">
          Meetings &amp; Events Hall
        </h2>
        <div className="w-full bg-[#EDE6CE] py-20  mt-[10%] ">
          <div className=" mx-auto grid grid-cols-12  items-start">
            <div className="col-span-12 lg:col-span-4 pl-20">
              <h3 className="text-primary text-[48px] font-creto font-normal leading-tight">
                Flexible Event <br />
                Spaces for Every <br />
                Occasion
              </h3>
            </div>

            <div className="col-span-12 lg:col-span-8 relative overflow-hidden -mt-52">
              <div
                className="flex transition-transform duration-700 ease-in-out w-[445] h-[530px]"
                style={{ transform: `translateX(-${index * STEP}px)` }}
              >
                {halls.map((item) => (
                  <div key={item.id} className=" shrink-0 mr-10 relative z-0">
                    <div className="">
                      <div className="">
                        <div className=" w-[446px] h-[292px] ">
                          <img
                            src={item.image}
                            alt={item.title}
                            className="w-full h-full object-cover"
                            loading="lazy"
                          />
                        </div>

                        <div className=" p-5 text-primary w-[446px] ">
                          <h4 className="font-calson text-[40px] leading-none ">
                            {item.title}
                          </h4>
                          <p className="mt-4 text-[24px] font-creto font-light  leading-8 ">
                            {item.content}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex justify-end gap-4 pr-20 ">
                <button
                  onClick={prev}
                  disabled={index === 0}
                  className={`w-[35px] h-[35px] rounded-full border border-[#B38A2E]
    flex items-center justify-center transition-all duration-300
    ${
      index === 0
        ? "opacity-40 cursor-not-allowed"
        : "hover:bg-[#B38A2E] hover:text-white"
    }`}
                >
                  <MdOutlineKeyboardArrowLeft size={22} />
                </button>

                {/* NEXT */}
                <button
                  onClick={next}
                  disabled={index === maxIndex}
                  className={`w-[35px] h-[35px] rounded-full border border-[#B38A2E]
    flex items-center justify-center transition-all duration-300
    ${
      index === maxIndex
        ? "opacity-40 cursor-not-allowed"
        : "hover:bg-[#B38A2E] hover:text-white"
    }`}
                >
                  <MdKeyboardArrowRight size={22} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="md:hidden  block w-full bg-[#FFFEF2]  overflow-hidden relative">
        <div className="px-5 sm:px-10 md:px-28 flex flex-col lg:flex-row justify-center   items-center gap-10 lg:gap-16">
          <div className="flex flex-col max-w-full lg:max-w-[602px]">
            <p className="font-cinzel font-normal text-[20px] sm:text-[28px] md:text-[44px] text-primary leading-snug md:leading-none">
              let’s celebrate your all auspicious events in our unforgettable
              venue.
            </p>
            <p className="mt-6 sm:mt-10 font-creto font-thin text-[16px] sm:text-[18px] md:text-[20px] text-primary leading-relaxed">
              Set in a meticulously restored Beaux-Arts building, The Chemists’
              Club Hotel offers a refined stay in the heart of Midtown
              Manhattan. Just steps from Bryant Park and the iconic locations
              nearby. Enjoy a seamless experience for all your events and
              meetings.
            </p>
          </div>

          <div className="flex gap-4 sm:gap-5 overflow-hidden h-[400px] sm:h-[500px] lg:h-[600px]">
            <div className="relative w-[40%] overflow-hidden">
              <div className="animate-scrollSlow flex flex-col gap-3 sm:gap-5">
                {[...leftFrames, ...leftFrames].map((img, i) => (
                  <div key={i} className="w-full">
                    <img
                      src={img}
                      className="w-full h-full object-cover"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="relative w-[60%] overflow-hidden">
              <div className="animate-scrollFast flex flex-col gap-3 sm:gap-5">
                {[...rightFrames, ...rightFrames].map((img, i) => (
                  <div key={i} className="w-full ">
                    <img
                      src={img}
                      className="w-full h-full object-cover"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-primary font-calson text-center text-[30px] mt-[10%]">
          Meetings &amp; Events Hall
        </h2>

        <div className="w-full bg-[#EDE6CE] mt-8">
          <div className="w-full mx-auto px-5">
            <div className="grid grid-cols-1 gap-6 pt-10 pb-12">
              <h3 className="text-primary text-[30px] font-creto leading-tight">
                Flexible Event <br />
                Spaces for Every <br />
                Occasion
              </h3>

              <div ref={trackWrapRef} className="relative overflow-hidden">
                <div
                  className="flex transition-transform duration-700 ease-in-out"
                  style={{
                    transform: `translateX(-${index * STEP}px)`,
                    gap: `${GAP}px`,
                  }}
                >
                  {halls.map((item) => (
                    <div
                      key={item.id}
                      className="shrink-0"
                      style={{ width: `${cardW}px` }}
                    >
                      {/* IMAGE */}
                      <div className="overflow-hidden w-full h-[240px] md:h-[290px]">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>

                      {/* CONTENT */}
                      <div className="pt-4 text-primary">
                        <h4 className="font-calson text-[20px] md:text-[24px]">
                          {item.title}
                        </h4>

                        <p className="mt-3 text-[14px] md:text-[15px] text-primary/70 leading-7">
                          {item.content}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ARROWS */}
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={prev}
                    disabled={index === 0}
                    className={`w-[28px] h-[28px] rounded-full border border-[#B38A2E]
            flex items-center justify-center transition
            ${
              index === 0
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-[#B38A2E] hover:text-white"
            }`}
                  >
                    <MdOutlineKeyboardArrowLeft size={14} />
                  </button>

                  <button
                    onClick={next}
                    disabled={index === maxIndex}
                    className={`w-[28px] h-[28px] rounded-full border border-[#B38A2E]
            flex items-center justify-center transition
            ${
              index === maxIndex
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-[#B38A2E] hover:text-white"
            }`}
                  >
                    <MdKeyboardArrowRight size={14} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventHall;
